<div class="w-full h-full flex flex-col">
  <div class="p-4 bg-surface-50 rounded-2xl ">
    <create-ta-step-container [currentStep]="currentStep()" [(travellerId)]="travellerId"></create-ta-step-container>
  </div>
  <div class="flex justify-end gap-2 pt-4">
    <p-button size="small" label="Close" severity="secondary" (click)="closeDialog(null)" />
  </div>
</div>
